import classNames from '@sindresorhus/class-names';
import {LinkProps as NextLinkProps} from 'next/dist/client/link';
import NextLink from 'next/link';
import {forwardRef, ReactNode} from 'react';

import {Text} from '../Text';
import {TextProps} from '../Text/TextProps';
import styles from './Link.module.scss';

type LinkPropsInner = Partial<Omit<TextProps<'a'>, 'href' | 'as'>> & {
  children: ReactNode;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
};

export type LinkProps = LinkPropsInner &
  Omit<NextLinkProps, keyof LinkPropsInner | 'as'>;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const {startIcon, endIcon, children, className, ...otherProps} = props;

  return (
    <Text
      as={NextLink}
      ref={ref}
      color="core-text-link"
      typography="control-m"
      className={classNames(styles.root, className)}
      {...otherProps}
    >
      {startIcon}
      <span>{children}</span>
      {endIcon}
    </Text>
  );
});

Link.displayName = 'Link';
